import { observer } from 'mobx-react';
import * as React from 'react';
import { VoiceSearchViewController } from '../../internal/controllers/VoiceSearchViewController';
import { SpeakScreen } from '../../internal/views/voice-search/SpeakScreen';
import { diContainer, serviceNames } from '../../service-setup/diContainer';
import { Mobile } from '../../internal/views/common/SearchMediaQueries';
import { translate, ITranslationsCollection } from '@estee/elc-service';
import { VoiceTranscoder } from '@estee/elc-voice-transcoder';
import { classes } from '../../internal/utils/Classes';

export interface IVoiceSearch {
    config: {
        searchUrl: string;
        phrases: string[];
        silenceTimeout: number;
        stopTimeout: number;
    };
    className?: string;
    translations?: ITranslationsCollection;
}

const voiceTranscoderClassnames = classes('search-voice-transcoder');

@translate(['voiceSearchIconLabel'])
@observer
export class VoiceSearch extends React.Component<IVoiceSearch> {
    private voiceSearchViewController: VoiceSearchViewController;

    constructor(props: IVoiceSearch) {
        super(props);
        this.voiceSearchViewController = diContainer.get(serviceNames.voiceSearchViewController);
        this.voiceSearchViewController.setSearchUrl(this.props.config.searchUrl);
    }

    public render() {
        const {
            transcriptionCallback,
            onSuccessCallback,
            onErrorCallback,
            closeSpeakScreen,
            data: {
                isSpeakScreenOpen,
                allowPermission,
                voiceSearchFailure,
                voiceSearchTerm,
                searching,
                config
            }
        } = this.voiceSearchViewController;

        const { voiceSearchIconLabel } = this.props.translations as ITranslationsCollection;
        const { phrases, silenceTimeout, stopTimeout } = this.props.config;

        return (
            <Mobile>
                <VoiceTranscoder
                    silenceTimeout={silenceTimeout}
                    stopTimeout={stopTimeout}
                    phrases={phrases}
                    transcriptionCallback={transcriptionCallback}
                    apiKey={config.voiceSearch.google.apiKey}
                    className={voiceTranscoderClassnames}
                    isListening={isSpeakScreenOpen}
                    languageCode={config.voiceSearch.google.languageCode}
                    onSuccessCallback={onSuccessCallback}
                    onErrorCallback={onErrorCallback}
                    dataTestId={'SEA-Voice-Icon'}
                    title={voiceSearchIconLabel}
                />
                <SpeakScreen
                    isSpeakScreenOpen={isSpeakScreenOpen}
                    allowPermission={allowPermission}
                    voiceSearchFailure={voiceSearchFailure}
                    voiceSearchTerm={voiceSearchTerm}
                    searching={searching}
                    closeSpeakScreen={closeSpeakScreen}
                />
            </Mobile>
        );
    }
}

export default VoiceSearch;
